import { EPermissionGroupType, TPermissionGroup } from '@/models/PermissionGroup';
import React, { useEffect, useState } from 'react';
import { useImmer } from 'use-immer';
import { SelectMember, SelectRole } from '@/components/PeopleRoleSelect/SelectRoleOrMemberModal/types';
import { createOrUpdatePermissionGroup, listPermissionGroup } from '@/services/PermissionGroupRequest';
import { useRequest } from '@@/plugin-request/request';
import { useUpdateEffect } from 'ahooks';
import styles from './index.less';
import cx from 'classnames';
import { Checkbox, Col, Row, Tag } from 'antd';
import { PlusSquareOutlined } from '@ant-design/icons';
import PeopleRoleSelect from '@/components/PeopleRoleSelect';

type TProps = {
  title: string;
  tips?: string;
  subTitle: string;
  subTitle2?: string;
  functions?: { label: string; value: string }[]; // 职能选择
  type: EPermissionGroupType;
};
const PermissionCard = ({
                          title,
                          tips,
                          subTitle,
                          subTitle2,
                          functions,
                          type,
                        }: TProps) => {
  const [visible, setVisible] = useState(false);
  const [permissionGroup, updatePermissionGroup] = useImmer<TPermissionGroup>({
    name: title,
    type: type,
    permission: {},
  });
  const [isFirstRun, setIsFirstRun] = useState(true);
  const selected: string[] = [];
  const memberNodes: SelectMember[] = [];
  const groupNodes: SelectRole[] = [];
  permissionGroup.selected?.personList.forEach((item) => {
    selected.push(`${item.nameEn}-${item.nameZh}`);
    memberNodes.push({
      id: item.pernr,
      completeName: `${item.nameEn}-${item.nameZh}`,
    });
  });
  permissionGroup.selected?.roleList.forEach((item) => {
    selected.push(item.name);
    groupNodes.push({
      id: item.id,
      name: item.name,
      completeName: item.name,
    });
  });

  const { run: listPermissionGroupRequest } = useRequest(
    () => {
      return listPermissionGroup(type);
    },
    {
      manual: true,
      onSuccess: (res) => {
        if (res.length > 0) {
          updatePermissionGroup((draft) => {
            draft.permission = res[0].permission;
            draft.name = res[0].name;
            draft.id = res[0].id;
            draft.selected = res[0].selected;
          });
        }
      },
    },
  );

  const { run: updateSpacePermissionGroupRequest } = useRequest(
    () => {
      return createOrUpdatePermissionGroup(permissionGroup);
    },
    {
      manual: true,
    },
  );

  useEffect(() => {
    listPermissionGroupRequest();
  }, []);

  const isSelected = permissionGroup.selected && (permissionGroup.selected.personList?.length > 0 || permissionGroup.selected.roleList?.length > 0);

  useUpdateEffect(() => {
    if (!isFirstRun) {
      updateSpacePermissionGroupRequest();
    } else {
      setIsFirstRun(false);
    }
  }, [permissionGroup]);

  return (
    <div className={styles.common_permission_manage_wrapper}>
      <div className={styles.title}>
        <span className={cx('text-sm', 'font-[650]')}>{title}</span>
        {tips && (
          <span className={cx('text-808696', 'ml-[8px]', 'text-[13px]', 'leading-4')}>{tips}</span>
        )}
      </div>
      <div className={'text-808696 mt-[16px]'}>
        <span className={cx('text-sm')}>{subTitle}</span>
      </div>
      {functions && (
        <div className={'mt-[13px] max-w-full'}>
          <Row>
            {functions.map((item) => (
              <Col key={item.value} span={24 / functions.length}>
                <Checkbox
                  checked={permissionGroup?.permission[item.value]}
                  onChange={(e) => {
                    console.log(e.target.checked);
                    updatePermissionGroup((draft) => {
                      draft.permission[item.value] = e.target.checked;
                    });
                  }}
                >
                  {item.label}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </div>
      )}
      {subTitle2 && (
        <div className={'text-808696 mt-[16px]'}>
          <span>{subTitle2}</span>
        </div>
      )}
      {isSelected ? (
        <div
          className={styles.management_people}
          // style={{ cursor: yes ? 'not-allowed' : 'pointer' }}
          style={{ cursor: 'pointer', marginBottom: '24px' }}
          onClick={() => {
            setVisible(true);
          }}
        >
          {selected.map((item) => (
            <Tag>{item}</Tag>
          ))}
        </div>
      ) : (
        <div
          className={cx(
            'mt-[24px]',
            'cursor-pointer',
            'text-808696',
            'flex',
            'items-center',
            'justify-center',
            styles.management_people,
          )}
          style={{ background: '#F8F8FA', marginBottom: '24px' }}
          onClick={() => {
            setVisible(true);
          }}
        >
          <PlusSquareOutlined className={cx('mr-[8px]')} />
          点击添加权限组人员
        </div>
      )}
      <PeopleRoleSelect
        memberNodes={memberNodes}
        groupNodes={groupNodes}
        mode="modal"
        visible={visible}
        onClose={() => setVisible(false)}
        onOk={(_memberNodes: SelectMember[], _groupNodes: SelectRole[]) => {
          console.log(_memberNodes, _groupNodes);
          updatePermissionGroup((draft) => {
            draft.selected = {
              roleList: _groupNodes.map((item) => {
                return {
                  id: item.id,
                  name: item.completeName,
                };
              }),
              personList: _memberNodes.map((item) => {
                return {
                  pernr: item.id,
                  nameEn: item.completeName.split('-')[0],
                  nameZh: item.completeName.split('-')[1],
                };
              }),
            };
          });
          setVisible(false);
        }}
      />
    </div>
  );
};

export default PermissionCard;